import { State } from '../Store';

export const selectVehicleTypes = (state: State) => state.vehicleTypes;
